module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid p-0 objectview-wrapper"
  }, [_c('div', {
    staticClass: "row no-gutters header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-header', {
    attrs: {
      "name": _vm.objectName,
      "id": _vm.objectId,
      "breadcrumb": _vm.breadcrumb,
      "previewUrl": _vm.objectPreviewUrl,
      "status": _vm.objectStatus,
      "stati": _vm.stati,
      "isProductive": _vm.objectIsProductive
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters view-menu"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-menu', {
    attrs: {
      "items": _vm.subviews,
      "jumpTo": _vm.jumpTo,
      "lang": _vm.objectLanguage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row no-gutters main"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-main', [_c('keep-alive', [(_vm.objectDataset) ? _c(_vm.view, {
    tag: "component",
    attrs: {
      "dataset": _vm.objectDataset
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sidebar"
    }
  }, [(_vm.sidebar.visible) ? _c('erco-sidebar', {
    attrs: {
      "sidebar": _vm.sidebar
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('erco-cloak') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c513dcb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ErcoObjectView.vue
// module id = 631
// module chunks = 0